import JSX from "../../helpers/react.js";

export function EditActionBtns(){
    return (
        <div>
            <button className="main-button send-edit col bordered">Сохранить</button>
            <button className="main-button transparent send-cancel col bordered">Отмена</button>
        </div>
    )

}
